import {computed, MaybeRefOrGetter, toValue, watchEffect} from 'vue'
import {IconPrefix} from '@fortawesome/fontawesome-svg-core'
import {isFontAwesomeIconRegistered, loadFontAwesomeIcon} from '../functions/loadFontAwesomeIcon'

export function useFontAwesomeIcon(prefix: MaybeRefOrGetter<IconPrefix>, iconName: MaybeRefOrGetter<string | null>) {
  const isIconRegistered = computed(() => {
    const name = toValue(iconName)
    return !!name && isFontAwesomeIconRegistered(toValue(prefix), name)
  })

  watchEffect(() => {
    const name = toValue(iconName)
    if(name && !isIconRegistered.value) {
      void loadFontAwesomeIcon(toValue(prefix), name)
    }
  })

  return {
    isIconRegistered,
  }
}
